import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import dayjs from "dayjs";
import React, { useMemo } from "react";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export function LineChart({ date, dataChart }) {
  const daysInMonth = dayjs(
    `${date.year}-${date.month}`,
    "YYYY-M"
  ).daysInMonth();
  const daysArray = useMemo(
    () => Array.from({ length: daysInMonth }, (_, i) => i + 1),
    [daysInMonth]
  );

  const data = useMemo(
    () => ({
      labels: daysArray,
      datasets: [
        {
          label: "Pay",
          data: dataChart.map((item) => item.pay || item.Pay || 0),
          fill: false,
          borderColor: "#78d6d5",
        },
        {
          label: "Distribution",
          data: dataChart.map(
            (item) => item.distribution || item.Distribution || 0
          ),
          fill: false,
          borderColor: "#9ca116",
        },
        {
          label: "NoCount",
          data: dataChart.map((item) => item.no_count || item.NoCount || 0),
          fill: false,
          borderColor: "#ae54cc",
        },
        {
          label: "BuyBack",
          data: dataChart.map((item) => item.buy_back || item.BuyBack || 0),
          fill: false,
          borderColor: "#e6b55c",
        },
        {
          label: "K-Pay",
          data: dataChart.map((item) => item.k_pay || item.KPay || 0),
          fill: false,
          borderColor: "#3fc736",
        },
        {
          label: "K-Distribution",
          data: dataChart.map(
            (item) => item.k_distribution || item.KDistribution || 0
          ),
          fill: false,
          borderColor: "#3235db",
        },
        {
          label: "K-NoCount",
          data: dataChart.map((item) => item.k_no_count || item.KNoCount || 0),
          fill: false,
          borderColor: "#d14532",
        },
        {
          label: "K-BuyBack",
          data: dataChart.map((item) => item.k_buy_back || item.KBuyBack || 0),
          fill: false,
          borderColor: "#003300",
        },
      ],
    }),
    [daysArray, dataChart]
  );

  const options = useMemo(
    () => ({
      maintainAspectRatio: false,
      responsive: true,
      scales: {
        x: {
          type: "category",
        },
        y: {
          beginAtZero: true,
        },
      },
    }),
    []
  );

  return <Line data={data} options={options} />;
}
